import * as React from 'react'
import { tw } from 'utils/classnames'

/**
 * The 8-point sparkle motif from the mockup — used in the logo, badges, the
 * image tool, the premium card and the floating decorations. Studio's
 * `Stars01Icon` is a different shape, so we render the exact path for fidelity.
 * Color comes from `currentColor`; size from `className` (or a parent
 * `[&_svg]:size-*`).
 */
export function SparkleStar({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={tw('shrink-0', className)}
      fill="currentColor"
      aria-hidden
      focusable="false"
    >
      <path d="M12 1 L14.4 9.6 L23 12 L14.4 14.4 L12 23 L9.6 14.4 L1 12 L9.6 9.6 Z" />
    </svg>
  )
}
